// extracted by mini-css-extract-plugin
module.exports = {"editButton":"AddressCard-EditButton-module--edit-button--3k5gF"};